const headConfig = [];
const rowsConfig = ['name'];

export { headConfig, rowsConfig };
